(() => {
  const root = document.querySelector('[data-ab-cfg]');
  if (!root) return;
  const data = JSON.parse(document.querySelector('[data-cfg-data]').textContent);
  const $ = (q) => root.querySelector(q);
  const $$ = (q) => [...root.querySelectorAll(q)];
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  // Engelse site: woordenboek NL naar EN uit snippets/ab-i18n-configurator.liquid (staat alleen op /en/ in de pagina). Nederlands blijft de terugval.
  // Optiewaarden (Hard Acryl, Zwart, Goud, logonamen) blijven Nederlandse sleutels in de logica; alleen wat de bezoeker ziet gaat door tr().
  // tr zoekt eerst de hele tekst; lukt dat niet, dan een patroon met {naam} (bijvoorbeeld een melding met een getal).
  const I18N = (() => { try { const e = document.querySelector('script[data-ab-i18n="configurator"]'); return e ? JSON.parse(e.textContent) : null; } catch (e) { return null; } })();
  const EN = !!I18N;
  let PAT = null;
  const tr = (s) => {
    if (!EN || typeof s !== 'string' || !s) return s;
    if (Object.prototype.hasOwnProperty.call(I18N, s) && typeof I18N[s] === 'string') return I18N[s];
    if (!PAT) PAT = Object.keys(I18N).filter((k) => /\{\w+\}/.test(k)).map((k) => {
      const names = [];
      const rx = new RegExp('^' + k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\\\{(\w+)\\\}/g, (m, n) => { names.push(n); return '(.+?)'; }) + '$');
      return { rx, names, en: I18N[k] };
    });
    for (const p of PAT) {
      const m = p.rx.exec(s);
      if (m && typeof p.en === 'string') return p.en.replace(/\{(\w+)\}/g, (x, n) => { const i = p.names.indexOf(n); return i >= 0 ? tr(m[i + 1]) : x; });
    }
    return s;
  };
  const trf = (s, m) => String(tr(s)).replace(/\{(\w+)\}/g, (x, k) => (k in m ? m[k] : x));
  const AND = ' ' + tr('en') + ' ';
  const LOC = EN ? 'en-GB' : 'nl-NL';
  const listNl = (arr) => (arr.length < 2 ? arr.join('') : arr.slice(0, -1).join(', ') + AND + arr[arr.length - 1]);

  const COLORS = { Transparant: 'rgba(196,224,234,.75)', Zwart: '#25242a', Wit: '#f4f2ee', Groen: '#3fbf8f', Rood: '#d63a2f', Blauw: '#2f5fd0',
    'Speciale kleur': 'conic-gradient(from 200deg,#f2557a,#ffc53d,#3fbf8f,#2f4fd8,#7a4cc2,#f2557a)' };
  const FLTS = ['DR', 'DM', 'DI', 'DIM'];
  const FILTER_COL = { DR: '#8a8d91', DM: '#2f5fd0', DI: '#f3b62f', DIM: '#c9b28f' };
  const FILTER_NAME = { DR: tr('DR · Algemeen'), DM: tr('DM · Muziek & communicatie'), DI: tr('DI · Industrie, bouw & productie'), DIM: tr('DIM · Impulsgeluid') };
  const GEM_BG = { Zilver: 'radial-gradient(circle at 35% 30%,#fff,#c9ccd1 50%,#8e939a)', Goud: 'radial-gradient(circle at 35% 30%,#fff6d0,#e2b84a 50%,#a77c1c)', 'Roségoud': 'radial-gradient(circle at 35% 30%,#ffe9e0,#e0a08a 50%,#a96553)' };
  const GEM_RIM = { Zilver: '#b9bcc1', Goud: '#d4a63a', 'Roségoud': '#d39580' };
  // E = eigen logo (vanaf 10 stuks), met 6 tekens uit het ontwerp (zie logotool/SPEC.md). Zonder logo staat er alleen een E.
  const CODE_RX = /^AB-([HS])(\d+)-(DR|DM|DI|DIM)-(N|L\d*|G[0-2]|E(?:[A-HJ-NP-Z2-9]{6})?)$/i;
  const LK = data.lk || {};
  const ssGet = (k) => { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch { return null; } };
  const ssSet = (k, v) => { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch { /* geen opslag */ } };
  const ssDel = (k) => { try { sessionStorage.removeItem(k); } catch { /* geen opslag */ } };
  const ssRaw = (k, v) => { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch { /* geen opslag */ } };
  const ssHas = (k) => { try { return sessionStorage.getItem(k) === '1'; } catch { return false; } };
  const lsGet = (k) => { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch { return null; } };
  const lsSet = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* geen opslag */ } };
  // Meten zonder derden: assets/ab-meten.js (window.abMeet) publiceert via Shopify.analytics.publish en alleen met toestemming.
  // Is die helper er nog niet, dan gaat de gebeurtenis in de wachtrij window.abMeetQ, die de helper bij het laden leegleest.
  const meet = (naam, data) => {
    try {
      if (typeof window.abMeet === 'function') window.abMeet(naam, data || {});
      else (window.abMeetQ = window.abMeetQ || []).push([naam, data || {}]);
    } catch (e) { /* meten mag nooit iets breken */ }
  };
  const finMeet = (s) => ({ logo: 'standaardlogo', gem: 'sieraad', eigen: 'eigen_logo' }[s.fin] || 'geen');
  // Eigen logo: de klanttool (assets/ab-logo-klant.js) laadt pas als iemand die keuze maakt
  const lkPanel = root.querySelector('[data-lk]');
  const lkQuote = root.querySelector('[data-lk-quote]');
  const hasEigen = !!(lkPanel && root.querySelector('[data-eigen-opt]') && window.fetch && window.Promise && window.HTMLCanvasElement);
  let klant = null, klantP = null, pendingLogo = '';
  if (hasEigen) root.querySelector('[data-eigen-opt]').hidden = false;
  // teksten voor het advies uit de keuzehulp (bewerkbaar in de sectie-instellingen)
  const T = Object.assign({
    advH: 'Jouw advies uit de keuzehulp', advH2: 'Extra filters bij dit ontwerp', advMain: 'Hoofdfilter in je oordop',
    advExtraH: 'Extra filters', advExtraT: 'Het filter in je oordop is wisselbaar. Met een extra filterset gebruik je dezelfde oordoppen ook voor deze situaties.',
    req: 'Extra filterset aanvragen', reqNote: 'Voor deze extra filterset staat nog geen prijs online. Vraag hem aan per mail, je advies en ontwerpcode staan er al in.',
    mail: 'info@audibling.nl', why: {},
    totalL: 'Prijs inclusief aanmeten', payNote: 'Je betaalt bij de audicien', apptL: 'Maak een afspraak bij een audicien', apptU: '/pages/advies-aanvragen',
    pdfH: 'Neem dit mee naar de audicien',
    shareTitle: 'Mijn Audibling ontwerp', mailSubj: 'Mijn Audibling ontwerp', pdfOk: 'Je PDF is bewaard. Neem hem mee naar de audicien.', shareOk: 'Je ontwerp is gedeeld.',
    mailBody: 'Mijn ontwerpcode is [code].\nMijn ontwerp staat op [link]\nNeem je ontwerpcode of de PDF mee naar een aangesloten audicien.',
    whereH: 'Hier kun je terecht', whereCall: 'Noem je ontwerpcode als je belt.', whereAll: 'Alle audiciens op de kaart',
    whereAppt: 'Een afdruk maken duurt gemiddeld 10 tot 15 minuten. Het aanmeten zit in de prijs en je betaalt bij de audicien.',
    qrL: 'Scan om je ontwerp online te openen',
    pdfNext: 'Maak met deze PDF of je ontwerpcode een afspraak bij een aangesloten audicien. Die maakt een afdruk van je oren, het aanmeten zit in de prijs. Je betaalt bij de audicien. Je oordoppen zijn ongeveer drie weken na het aanmeten klaar. Of je ze ophaalt of laat opsturen, spreek je af met je audicien.',
  });
  Object.entries(data.t || {}).forEach(([k, v]) => { if (v) T[k] = v; });
  // op /en/ zijn de standaardteksten uit de sectie-instellingen nog Nederlands: via het woordenboek (ook het pad naar de audicienkaart)
  if (EN) {
    Object.keys(T).forEach((k) => { if (typeof T[k] === 'string') T[k] = tr(T[k]); });
    if (T.why) Object.keys(T.why).forEach((k) => { T.why[k] = tr(T.why[k]); });
    ['priceNote', 'hint', 'thanksH', 'thanks', 'nextH', 'next'].forEach((k) => { if (typeof LK[k] === 'string') LK[k] = tr(LK[k]); });
  }
  // aangesloten audiciens voor de PDF (uit de metaobjects, zelfde velden als de audicienkaart)
  let DEALERS = [];
  try { DEALERS = JSON.parse((document.querySelector('[data-cfg-dealers]') || {}).textContent || '[]').filter((d) => d && d.name); } catch { DEALERS = []; }

  // meerprijzen: "titel|prijs(centen);..."
  const addons = {};
  (data.addons || '').split(';').filter(Boolean).forEach((row) => {
    const [title, price] = row.split('|');
    const t = String(title || '').toLowerCase();
    const key = t.startsWith('filter dim') ? 'DIM' : t.startsWith('filter di') ? 'DI' : t.startsWith('filter dm') ? 'DM'
      : t.includes('zilver') ? 'gem:Zilver' : t.includes('roségoud') || t.includes('rosegoud') ? 'gem:Roségoud' : t.includes('goud') ? 'gem:Goud' : t.includes('logo') ? 'logo' : null;
    if (key) addons[key] = { title, price: +price };
  });
  // prijs van een extra filterset: "optie|prijs(centen);..." met de filtercode als eerste woord van de optie.
  // Extra filtersets horen bij het ontwerp: ze tellen mee in de prijs en staan in de PDF en de ontwerplink. Je betaalt ze bij de audicien.
  const sets = {};
  (data.sets || '').split(';').filter(Boolean).forEach((row) => {
    const [title, price] = row.split('|');
    const f = (title || '').trim().split(' ')[0].toUpperCase();
    if (f && FLTS.includes(f)) sets[f] = { title, price: +price };
  });
  const canBuy = (f) => !!sets[f];

  const plain = (cents) => (EN ? '€' + (cents / 100).toFixed(2) : '€' + (cents / 100).toFixed(2).replace('.', ','));

  // kleuren uit varianten
  const colors = [...new Set(data.variants.map((v) => v.o2))];
  const swWrap = $('[data-colors]');
  // de kleuren staan al in de HTML (zelfde opbouw); alleen als ze ontbreken hier opbouwen
  if (!swWrap.querySelector('input[name="col"]')) swWrap.innerHTML = colors.map((c, i) => `<label class="ab-cfg__sw" title="${EN ? esc(tr(c)) : c}"><input type="radio" name="col" value="${c}"${i === 0 ? ' checked' : ''}><i style="background:${COLORS[c] || '#ccc'}"></i><span>${EN ? esc(tr(c)) : c}</span></label>`).join('');

  const val = (n) => (root.querySelector(`input[name="${n}"]:checked`) || {}).value;
  const variantFor = (mat, col) => data.variants.find((v) => v.o1 === mat && v.o2 === col);

  const state = () => ({ mat: val('mat'), col: val('col'), flt: val('flt'), fin: val('fin'), gem: val('gem'), logo: val('stdlogo') });
  const logoInputs = () => $$('input[name="stdlogo"]');
  const logoIndex = (name) => Math.max(0, logoInputs().findIndex((i) => i.value === name));
  const code = (s, finOverride) => {
    const m = s.mat === 'Siliconen' ? 'S' : 'H';
    const c = Math.max(0, colors.indexOf(s.col));
    const fin = finOverride || s.fin;
    const f = fin === 'logo' ? 'L' + logoIndex(s.logo) : fin === 'gem' ? 'G' + ['Zilver', 'Goud', 'Roségoud'].indexOf(s.gem)
      : fin === 'eigen' ? ((klant && klant.suffix()) || 'E') : 'N';
    return `AB-${m}${c}-${s.flt}-${f}`;
  };
  const decode = (str) => {
    const m = CODE_RX.exec(str || '');
    if (!m) return;
    const set = (n, v) => { const el = root.querySelector(`input[name="${n}"][value="${v}"]`); if (el) el.checked = true; };
    set('mat', m[1].toUpperCase() === 'S' ? 'Siliconen' : 'Hard Acryl');
    if (colors[+m[2]]) set('col', colors[+m[2]]);
    set('flt', m[3].toUpperCase());
    const f = m[4].toUpperCase();
    set('fin', f[0] === 'L' ? 'logo' : f[0] === 'G' ? 'gem' : f[0] === 'E' && hasEigen ? 'eigen' : 'none');
    if (f[0] === 'L' && f.length > 1 && logoInputs()[+f.slice(1)]) logoInputs()[+f.slice(1)].checked = true;
    if (f[0] === 'G') set('gem', ['Zilver', 'Goud', 'Roségoud'][+f[1]]);
  };

  // Advies uit de keuzehulp. Formaat van de link: #ontwerp=CODE&extra=DM,DIM&sterkte=DM15,DIM&bron=keuzehulp
  // Het hoofdfilter staat in de code. Staat het hoofdfilter ook in extra, dan is dat een tweede filterset in een andere sterkte.
  // sterkte (optioneel) geeft de geadviseerde sterktes door, zodat de audicien ze in de PDF ziet.
  // extra, sterkte en bron blijven in de link staan, ook in de deellink.
  let advice = null;            // { main, order: [hoofdfilter, ...extra], second: tweede set van het hoofdfilter, str: { DR: ['15', '20'] } }
  let bron = '';
  let strRaw = '';
  const dropped = new Set();    // extra filtersets die de klant zelf heeft uitgezet (sleutel DM, of DR2 voor een tweede DR-set)
  const fOf = (k) => k.replace(/2$/, '');
  const isSecond = (k) => /2$/.test(k);
  const readHash = () => {
    const h = new URLSearchParams(location.hash.replace(/^#/, ''));
    const c = (h.get('ontwerp') || new URLSearchParams(location.search).get('ontwerp') || '').trim().toUpperCase();
    const extra = (h.get('extra') || '').toUpperCase().split(/[\s,]+/).filter((f) => FLTS.includes(f));
    const str = (h.get('sterkte') || '').toUpperCase().split(/[\s,]+/).filter((x) => /^(DR|DM|DI|DIM)\d{1,2}$/.test(x)).slice(0, 12);
    const logo = (h.get('logo') || '').trim();
    return { code: c, extra: [...new Set(extra)], str: [...new Set(str)], bron: (h.get('bron') || '').toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 30),
      logo: /^1\.[A-Za-z0-9_-]{8,20000}$/.test(logo) ? logo : '' };
  };
  const applyHash = (h) => {
    decode(h.code);
    bron = h.bron;
    pendingLogo = '';
    if (hasEigen) {
      if (val('fin') === 'eigen') pendingLogo = h.logo || 'leeg';
      // terug uit de keuzehulp: die kent geen E-codes, dus we hebben het eigen logo even bewaard
      const terug = ssGet('ab-lk-terug');
      if (terug && h.bron === 'keuzehulp' && /-N$/i.test(h.code) && Date.now() - terug.at < 3 * 3600e3) {
        const el = root.querySelector('input[name="fin"][value="eigen"]');
        if (el) { el.checked = true; pendingLogo = terug.logo || 'leeg'; }
      }
      ssDel('ab-lk-terug');
      if (pendingLogo && klant) restoreLogo();
    }
    dropped.clear();
    const main = val('flt');
    const str = {};
    h.str.forEach((x) => { const m = /^(DIM|DR|DM|DI)(\d+)$/.exec(x); if (m) (str[m[1]] = str[m[1]] || []).push(m[2]); });
    Object.values(str).forEach((l) => l.sort((a, b) => a - b));
    advice = h.extra.length || bron === 'keuzehulp'
      ? { main, order: [main, ...h.extra.filter((f) => f !== main)], second: h.extra.includes(main), str } : null;
    strRaw = advice ? h.str.join(',') : '';
  };
  // extra filtersets = de geadviseerde filters die niet als hoofdfilter in de oordop zitten, plus een tweede set van het hoofdfilter
  // als de keuzehulp twee sterktes adviseerde, zonder de sets die de klant zelf heeft uitgezet
  const candidates = (s) => (advice ? [...advice.order.filter((f) => f !== s.flt), ...(advice.second && s.flt === advice.main ? [s.flt + '2'] : [])] : []);
  const extrasFor = (s) => candidates(s).filter((k) => !dropped.has(k));
  // het ontwerp met eigen logo gaat als laatste mee in de link (#logo=, zie logotool/SPEC.md)
  const logoParam = (s) => (s.fin !== 'eigen' ? '' : klant && klant.hasLogo() ? klant.hash() : pendingLogo && pendingLogo !== 'leeg' ? pendingLogo : '');
  const hashFor = (s) => {
    const ex = extrasFor(s).map(fOf), lp = logoParam(s);
    return '#ontwerp=' + code(s) + (ex.length ? '&extra=' + ex.join(',') : '') + (strRaw ? '&sterkte=' + strRaw : '') + (bron === 'keuzehulp' ? '&bron=' + bron : '') + (lp ? '&logo=' + lp : '');
  };
  // Een andere bron dan de keuzehulp is alleen voor de eerste weergave (uitleg en meten). Hij gaat niet mee in de link die je deelt.
  const restoreLogo = () => {
    const p = pendingLogo === 'leeg' ? '' : pendingLogo;
    const done = () => { pendingLogo = ''; render(); };
    Promise.resolve(klant.restore(p)).then(done, done);
  };
  const loadKlant = () => {
    if (klantP || !hasEigen) return klantP;
    klantP = new Promise((res, rej) => {
      if (window.ABLogoKlant) { res(); return; }
      const sc = document.createElement('script');
      sc.src = lkPanel.dataset.klant; sc.onload = res; sc.onerror = rej;
      document.head.appendChild(sc);
    }).then(() => {
      klant = window.ABLogoKlant.mount(bridge);
      if (pendingLogo) restoreLogo();
      render();
      return klant;
    }).catch(() => {
      klantP = null;
      const app = lkPanel.querySelector('[data-lk-app]');
      if (app) app.innerHTML = tr('<p class="ab-lk__err" role="alert">De logotool kon niet laden. Probeer het opnieuw of mail je logo naar <a href="mailto:info@audibling.nl">info@audibling.nl</a>.</p>');
    });
    return klantP;
  };
  const strTxt = (f) => {
    const l = advice && advice.str && advice.str[f];
    return l && l.length ? tr(l.length > 1 ? 'Geadviseerde sterktes' : 'Geadviseerde sterkte') + ' ' + listNl(l.map((n) => f + ' ' + n)) : '';
  };
  const setName = (k) => trf(isSecond(k) ? 'Tweede filterset {f}' : 'Extra filterset {f}', { f: fOf(k) });
  const shareUrl = (s) => location.origin + location.pathname + hashFor(s);
  const withUtm = (url) => {
    try { const u = new URL(url, location.origin); u.searchParams.set('utm_source', 'ontwerp-pdf'); u.searchParams.set('utm_medium', 'pdf'); return u.href; } catch { return url; }
  };
  // link naar de audicienkaart met de ontwerpcode (de kaart leest #ontwerp=)
  const kaartUrl = (c, utm) => {
    let u;
    try { u = new URL(T.apptU || tr('/pages/advies-aanvragen'), location.origin); } catch { u = new URL(tr('/pages/advies-aanvragen'), location.origin); }
    u.hash = 'ontwerp=' + c;
    if (utm) return withUtm(u.href);
    return u.origin === location.origin ? u.pathname + u.search + u.hash : u.href;
  };
  const mailHref = (s) => {
    const c = code(s), body = String(T.mailBody || '').replace(/\[code\]/g, c).replace(/\[link\]/g, shareUrl(s));
    return 'mailto:?subject=' + encodeURIComponent((T.mailSubj || T.shareTitle) + ' ' + c) + '&body=' + encodeURIComponent(body);
  };
  const fltImg = (f) => { const i = root.querySelector(`input[name="flt"][value="${f}"]`); const im = i ? i.closest('label').querySelector('img') : null; return im ? im.getAttribute('src') : ''; };
  const fltWhy = (f) => (T.why && T.why[f]) || '';
  const mailto = (s, ex) => {
    const lines = [tr('Hallo Audibling,'), '', tr('Ik wil graag een extra filterset bij mijn oordoppen.'), trf('Mijn ontwerpcode is {code}.', { code: code(s) }),
      trf('Het filter in mijn oordop is het {f}-filter.', { f: s.flt }), trf(ex.length === 1 ? 'Als extra filter wil ik het {lijst}.' : 'Als extra filters wil ik het {lijst}.', { lijst: listNl(ex.map((f) => trf('{f}-filter', { f }))) }),
      trf('Mijn ontwerp staat op {url}', { url: shareUrl(s) }), '', tr('Met vriendelijke groet,'), ''];
    return `mailto:${T.mail}?subject=${encodeURIComponent(`${T.req} (${ex.join(', ')})`)}&body=${encodeURIComponent(lines.join('\n'))}`;
  };
  let adviceKey = '';
  const renderAdvice = (s) => {
    const box = $('[data-advice]');
    if (!box) return;
    if (!advice) { box.hidden = true; box.innerHTML = ''; adviceKey = ''; return; }
    const cand = candidates(s);
    const key = [s.flt, advice.main, cand.join(','), bron].join('|');
    box.hidden = false;
    if (key !== adviceKey) {
      adviceKey = key;
      const fromHelp = bron === 'keuzehulp';
      const row = (f, small, str) => `<span class="ab-cfg__advimg">${fltImg(f) ? `<img src="${esc(fltImg(f))}" alt="" width="40" height="40">` : ''}</span>`
        + `<span class="ab-cfg__advtxt"><small>${esc(small)}</small><b>${esc(FILTER_NAME[f])}</b>${str ? `<em>${esc(str)}</em>` : ''}${fltWhy(f) ? `<span>${esc(fltWhy(f))}</span>` : ''}</span>`;
      let h = `<h3 class="ab-cfg__advh" tabindex="-1">${esc(fromHelp ? T.advH : T.advH2)}</h3>`;
      if (fromHelp) {
        h += `<div class="ab-cfg__advrow is-main">${row(advice.main, s.flt === advice.main ? T.advMain : tr('Advies voor je hoofdfilter'), strTxt(advice.main))}</div>`;
        if (s.flt !== advice.main) {
          h += `<p class="ab-cfg__advnote">${esc(trf('Je ontwerp heeft nu het {f}-filter.', { f: s.flt }))} <button type="button" class="ab-cfg__advlink" data-adv-reset>${esc(trf('Kies weer het {f}-filter', { f: advice.main }))}</button></p>`;
        }
      }
      if (cand.length) {
        h += `<p class="ab-cfg__advsub">${esc(T.advExtraH)}</p>${T.advExtraT ? `<p class="ab-cfg__advt">${esc(T.advExtraT)}</p>` : ''}<ul class="ab-cfg__advlist">`
          + cand.map((k) => {
            const f = fOf(k), lab = tr(isSecond(k) ? 'Tweede filterset in een andere sterkte' : 'Extra filterset bij je ontwerp');
            return `<li><label class="ab-cfg__advrow is-extra"><input type="checkbox" name="advx" value="${k}" data-adv-x>${row(f, canBuy(f) ? lab + ' · ' + plain(sets[f].price) : lab, isSecond(k) ? '' : strTxt(f))}</label></li>`;
          }).join('')
          + '</ul>'
          + `<div class="ab-cfg__advreq" data-adv-req><p>${esc(T.reqNote)}</p><a class="ab-cfg__advbtn" data-adv-mail href="#">${esc(T.req)}</a></div>`;
      }
      box.innerHTML = h;
    }
    box.querySelectorAll('[data-adv-x]').forEach((cb) => { cb.checked = !dropped.has(cb.value); });
    const ex = [...new Set(extrasFor(s).map(fOf))];
    const req = box.querySelector('[data-adv-req]');
    const exReq = ex.filter((f) => !canBuy(f));
    if (req) { req.hidden = !exReq.length; req.querySelector('[data-adv-mail]').href = mailto(s, exReq.length ? exReq : [...new Set(candidates(s).map(fOf))]); }
  };

  // Voorbeeldfoto kiezen. Volgorde: precies dit ontwerp, dezelfde kleur in het andere materiaal,
  // dezelfde kleur met een vergelijkbare versiering, dezelfde kleur zonder versiering, pas daarna transparant.
  // De tekening is alleen de laatste terugval. Het label zegt altijd wat er echt op de foto staat.
  const PHOTOS = data.photos || {};
  const MAT_CODE = (m) => (m === 'Siliconen' ? 'S' : 'H');
  const MAT_TXT = { H: 'hard acryl', S: 'siliconen' };
  const finKey = (s) => (s.fin === 'logo' ? 'L:' + (s.logo || '') : s.fin === 'gem' ? 'G:' + (s.gem || '') : 'N');
  const finTxt = (k) => (k[0] === 'L' ? trf('logo {naam}', { naam: tr(k.slice(2)) }) : k[0] === 'G' ? trf('sieraad {steen}', { steen: tr(k.slice(2)).toLowerCase() }) : '');
  // standaardlogo in de prijsregel en de PDF als patroon uit het woordenboek: NL "Logo Achterhoek", EN "Achterhoek logo" (24 oktober 2026)
  const logoTxt = (nm) => trf('Logo {naam}', { naam: tr(nm || '') });
  const pickPhoto = (s) => {
    const m = MAT_CODE(s.mat), o = m === 'H' ? 'S' : 'H', f = finKey(s);
    const cols = s.col && s.col !== 'Speciale kleur' ? [s.col, 'Transparant'] : ['Transparant'];
    const tries = [];
    cols.forEach((c) => {
      tries.push([m, c, f], [o, c, f]);
      if (f !== 'N') {
        const alt = Object.keys(PHOTOS).find((k) => k.startsWith(`${m}|${c}|${f[0]}:`)) || Object.keys(PHOTOS).find((k) => k.startsWith(`${o}|${c}|${f[0]}:`));
        if (alt) tries.push(alt.split('|'));
      }
      tries.push([m, c, 'N'], [o, c, 'N']);
    });
    for (const [pm, pc, pf] of tries) {
      const url = PHOTOS[`${pm}|${pc}|${pf}`];
      if (!url) continue;
      // altijd beschrijven wat er echt op de foto staat; zonder versiering zie je de witte filterdop, niet de kleur van jouw filter
      // het hele patroon gaat door het woordenboek, want de woordvolgorde verschilt per taal
      const base = trf('Voorbeeldfoto in {kleur} {mat}', { kleur: tr(pc).toLowerCase(), mat: tr(MAT_TXT[pm]) });
      const withFin = pf !== 'N' ? ' ' + trf('met {fin}', { fin: finTxt(pf) }) : '';
      const without = f !== 'N' ? ' ' + tr(f[0] === 'L' ? 'zonder logo' : 'zonder sieraad') : '';
      let cap = base;
      if (pf !== 'N') cap += withFin;
      else cap += (f !== 'N' ? without + ', ' : ' ') + tr('met witte filterdop');
      // geen foto in het gekozen materiaal (zoals transparant siliconen zonder sieraad): dat zeggen we er eerlijk bij (24 oktober 2026)
      if (pm !== m) cap += '. ' + trf('Een foto van dit ontwerp in {mat} hebben we nog niet.', { mat: tr(MAT_TXT[m]) });
      // kort label voor de kleine preview op mobiel; wijkt de foto af van het ontwerp, dan noemen we wat er wel op staat
      const exact = pm === m && pc === s.col && pf === f;
      const short = exact ? tr('Voorbeeldfoto') : base + (pf !== 'N' ? withFin : without);
      return { url, cap, short, gem: pf[0] === 'G', alt: trf('Audibling otoplastiek {mat} {kleur}', { mat: tr(MAT_TXT[pm]), kleur: tr(pc).toLowerCase() }) + withFin };
    }
    return null;
  };
  const view = $('.ab-cfg__view');
  const sized = (u) => {
    const r = view ? view.getBoundingClientRect() : { width: 600, height: 450 };
    const need = Math.min(r.width || 600, r.height || 450) * (window.devicePixelRatio || 1) * 1.2;
    const w = need > 900 ? 1250 : need > 600 ? 900 : need > 400 ? 600 : 400;
    return u + (u.includes('?') ? '&' : '?') + 'width=' + w;
  };
  const loaded = new Map();
  const preload = (src) => {
    if (!loaded.has(src)) {
      // wachten op load (werkt ook in een achtergrondtabblad), daarna kort op decode voor een vloeiende wissel
      loaded.set(src, new Promise((ok) => {
        const im = new Image();
        im.onload = () => {
          const d = im.decode ? im.decode().catch(() => {}) : null;
          Promise.race([d, new Promise((r) => setTimeout(r, 250))]).then(() => ok(true));
        };
        im.onerror = () => ok(false);
        im.src = src;
      }));
    }
    return loaded.get(src);
  };
  let photoTicket = 0;
  const showPhoto = (p) => {
    const pimg = root.querySelector('.ab-cfg__photo'), pcap = root.querySelector('.ab-cfg__photocap'), pshort = root.querySelector('.ab-cfg__photocap--s');
    const ticket = ++photoTicket;
    const hideCaps = () => { pcap.hidden = true; if (pshort) pshort.hidden = true; };
    if (!p) { pimg.hidden = true; hideCaps(); root.classList.remove('has-photo', 'photo-gem'); return; }
    const src = sized(p.url);
    const apply = (keep) => {
      if (!keep) {
        // de startfoto uit de HTML heeft een srcset, die zou een nieuwe src overrulen
        if (pimg.hasAttribute('srcset')) { pimg.removeAttribute('srcset'); pimg.removeAttribute('sizes'); }
        if (pimg.getAttribute('src') !== src) pimg.src = src;
      }
      pimg.dataset.base = p.url;
      if (view) view.classList.remove('is-wacht');
      pimg.dataset.full = p.url + (p.url.includes('?') ? '&' : '?') + 'width=1000';
      pimg.alt = p.alt; pimg.classList.toggle('is-gem', p.gem);
      pimg.hidden = false; pcap.hidden = false; pcap.textContent = p.cap;
      if (pshort) { pshort.hidden = false; pshort.textContent = p.short; }
      root.classList.add('has-photo');
      root.classList.toggle('photo-gem', p.gem);
    };
    // de startfoto staat al in de HTML: niet opnieuw laden
    if (!pimg.hidden && pimg.dataset.base === p.url && pimg.getAttribute('src')) { apply(true); return; }
    if (!pimg.hidden && pimg.getAttribute('src') === src) { apply(); return; }
    // eerst laden, dan pas wisselen, zodat het beeld nooit even leeg is
    root.classList.add('is-loading');
    preload(src).then((ok) => {
      if (ticket !== photoTicket) return;
      root.classList.remove('is-loading');
      if (ok) apply();
      else { pimg.hidden = true; hideCaps(); root.classList.remove('has-photo', 'photo-gem'); }
    });
  };
  // de andere kleuren van hetzelfde ontwerp alvast ophalen, zodat wisselen direct gaat
  let prefetchKey = '';
  const prefetchColors = (s) => {
    const key = s.mat + s.fin + s.logo + s.gem;
    if (key === prefetchKey) return;
    prefetchKey = key;
    const run = () => colors.forEach((c) => { const p = pickPhoto({ ...s, col: c }); if (p) preload(sized(p.url)); });
    (window.requestIdleCallback || ((fn) => setTimeout(fn, 400)))(run);
  };

  const origHint = ($('[data-hint]') || {}).innerHTML || '';
  let lastValue = null; // prijs zoals op het scherm, in euro (voor het meten van een bewaarde PDF)
  // ?ontwerp= (oude links) en, zodra Shopify het bezoek heeft kunnen tellen, utm_* uit de adresbalk, zodat een gekopieerde link schoon blijft
  let utmWeg = false;
  const cleanSearch = () => {
    const q = new URLSearchParams(location.search);
    q.delete('ontwerp');
    if (utmWeg) [...q.keys()].filter((k) => /^utm_/i.test(k)).forEach((k) => q.delete(k));
    const t = q.toString();
    return t ? '?' + t : '';
  };
  // Laatste ontwerp onthouden in deze browser (60 dagen, alleen code en link, geen persoonsgegevens). De audicienkaart leest dezelfde sleutel.
  let persistOn = false, persistT = 0, DEFAULT_HASH = '';
  const persist = (s, c) => {
    clearTimeout(persistT);
    persistT = setTimeout(() => {
      const h = hashFor(s);
      if (!h || h === DEFAULT_HASH) return;
      lsSet('ab-laatste-ontwerp', h.length > 4000 ? { code: c, t: Date.now() } : { code: c, hash: h, t: Date.now() });
    }, 600);
  };
  const render = () => {
    const s = state();
    const v = variantFor(s.mat, s.col);
    const eigen = s.fin === 'eigen' && hasEigen;
    // eerst de klanttool bijwerken, want de ontwerpcode en de prijs hangen af van materiaal, kleur en filter
    if (eigen) { if (klant) klant.sync(s); else loadKlant(); } else if (klant) klant.leave();
    root.classList.toggle('fin-eigen', eigen);
    // beschikbaarheid kleuren per materiaal
    $$('input[name="col"]').forEach((i) => { const vv = variantFor(s.mat, i.value); i.disabled = !vv || !vv.available; });
    // "vanaf"-prijzen materiaal
    $$('[data-from]').forEach((el) => {
      const ps = data.variants.filter((x) => x.o1 === el.dataset.from).map((x) => x.price);
      el.textContent = ps.length ? trf('vanaf {prijs}', { prijs: plain(Math.min(...ps)) }) : '';
    });
    $$('[data-add]').forEach((el) => {
      const k = el.dataset.add, a = k === 'gem' ? addons['gem:' + s.gem] : addons[k];
      el.textContent = k === 'DR' ? tr('inbegrepen') : a ? '+ ' + plain(a.price) : '';
    });
    // preview
    root.style.setProperty('--plug', COLORS[s.col] || '#2f5fd0');
    root.style.setProperty('--flt', FILTER_COL[s.flt]);
    root.classList.toggle('is-clear', s.col === 'Transparant');
    root.classList.toggle('is-light', s.col === 'Wit');
    root.classList.toggle('fin-gem', s.fin === 'gem');
    root.classList.toggle('fin-logo', s.fin === 'logo');
    root.style.setProperty('--gem', GEM_BG[s.gem] || 'none');
    root.style.setProperty('--rim', GEM_RIM[s.gem] || 'transparent');
    const lsel = logoInputs().find((i) => i.checked);
    const limg = lsel ? lsel.dataset.img : '';
    $$('.ab-cfg__plug .logo img').forEach((img) => { img.hidden = !limg; if (limg && img.getAttribute('src') !== limg) img.src = limg; });
    $$('[data-fin]').forEach((el) => { el.hidden = el.dataset.fin !== s.fin; });
    $('[data-custom]').hidden = s.col !== 'Speciale kleur';
    let photo = pickPhoto(s);
    const kc = eigen && klant ? klant.cap() : null;
    if (photo && kc) photo = Object.assign({}, photo, kc);
    showPhoto(photo);
    prefetchColors(s);
    const help = $('[data-help]');
    // de keuzehulp kent alleen N, L en G, dus bij een eigen logo gaat de code zonder logo mee (het logo bewaren we even)
    if (help) help.href = tr('/pages/filters') + '?ontwerp=' + encodeURIComponent(code(s, eigen ? 'none' : '')) + '#vergelijk';
    const fsel = root.querySelector('input[name="flt"]:checked');
    const fdesc = fsel ? fsel.closest('label').querySelector('small') : null;
    $('[data-flt-desc]').textContent = fdesc ? fdesc.textContent : '';
    $$('[data-out="mat"]').forEach((e) => (e.textContent = tr(s.mat)));
    $$('[data-out="col"]').forEach((e) => (e.textContent = tr(s.col)));
    $$('[data-out="flt"]').forEach((e) => (e.textContent = trf('{f}-filter', { f: s.flt })));
    renderAdvice(s);
    // samenvatting
    const lines = [];
    if (v) lines.push([`${tr(s.mat)} · ${tr(s.col)}`, v.price]);
    if (s.flt !== 'DR' && addons[s.flt]) lines.push([FILTER_NAME[s.flt], addons[s.flt].price]); else lines.push([FILTER_NAME.DR, 0]);
    if (s.fin === 'logo' && addons.logo) lines.push([logoTxt(s.logo), addons.logo.price]);
    if (s.fin === 'gem' && addons['gem:' + s.gem]) lines.push([trf('Sieraadsteen {steen}', { steen: tr(s.gem) }), addons['gem:' + s.gem].price]);
    const ex = extrasFor(s);
    ex.filter((k) => canBuy(fOf(k))).forEach((k) => lines.push([setName(k), sets[fOf(k)].price]));
    const exReq = [...new Set(ex.map(fOf).filter((f) => !canBuy(f)))];
    const pay = $('.ab-cfg__pay'), hint = $('[data-hint]'), qbtn = $('[data-quote-btn]');
    if (eigen) {
      // zakelijke prijs zoals de rekenhulp op /pages/zakelijk: per stuk, staffelkorting, excl. en incl. btw
      const sum = klant && klant.summary();
      $('[data-lines]').innerHTML = sum
        ? sum.lines.map(([l, p]) => `<div><span>${esc(l)}</span><b>${p < 0 ? '−' + sum.eur(-p) : sum.eur(p)}</b></div>`).join('')
        : '<div><span>' + esc(tr('Prijs wordt berekend')) + '</span><b></b></div>';
      $$('[data-out="total"]').forEach((e) => (e.textContent = sum ? sum.total : ''));
      $$('.ab-cfg__total > span, .ab-cfg__live small').forEach((e) => (e.textContent = tr('Indicatie excl. btw')));
      if (pay) pay.textContent = sum ? sum.note : '';
      if (hint && LK.hint && hint.dataset.mode !== 'eigen') { hint.textContent = LK.hint; hint.dataset.mode = 'eigen'; }
      lastValue = sum ? (EN && sum.exNum != null ? sum.exNum : (parseFloat(String(sum.total).replace(/[^\d,]/g, '').replace(',', '.')) || null)) : null;
      root.classList.toggle('lk-small', !!(sum && !sum.allowed));
    } else {
      $('[data-lines]').innerHTML = lines.map(([l, p]) => `<div><span>${esc(l)}</span><b>${p ? plain(p) : tr('inbegrepen')}</b></div>`).join('')
        + (exReq.length ? `<div class="is-advice"><span>${trf(exReq.length === 1 ? 'Extra filter {lijst} (advies)' : 'Extra filters {lijst} (advies)', { lijst: esc(listNl(exReq)) })}</span><b>${tr('aanvragen')}</b></div>` : '');
      const total = lines.reduce((t, [, p]) => t + p, 0);
      $$('[data-out="total"]').forEach((e) => (e.textContent = plain(total)));
      $$('.ab-cfg__total > span, .ab-cfg__live small').forEach((e) => (e.textContent = T.totalL));
      if (pay) pay.textContent = T.payNote;
      if (hint && hint.dataset.mode === 'eigen') { hint.innerHTML = origHint; hint.dataset.mode = ''; }
      lastValue = total / 100;
      root.classList.remove('lk-small');
    }
    if (qbtn) qbtn.hidden = !eigen;
    if (lkQuote) lkQuote.hidden = !eigen || !klant;
    const c = code(s);
    $$('[data-out="code"]').forEach((e) => (e.textContent = c));
    // de afspraakknop en de kaart krijgen de ontwerpcode mee
    const appt = $('[data-appt]');
    if (appt) appt.href = kaartUrl(c);
    const mm = $('[data-mailme]');
    if (mm) mm.href = mailHref(s);
    history.replaceState(null, '', location.pathname + cleanSearch() + hashFor(s));
    if (persistOn) persist(s, c);
  };
  // eerste wijziging door de bezoeker: meten (eenmalig per pagina) en vanaf nu het ontwerp onthouden
  let gestart = false, INIT = { herkomst: 'direct', bron: '', hadCode: false };
  const startMeting = () => {
    persistOn = true;
    if (gestart) return;
    gestart = true;
    // wie zelf iets kiest, begint een nieuw ontwerp: de kaart met het vorige ontwerp gaat weg (dat wordt nu overschreven)
    const rc = $('[data-resume]');
    if (rc && !rc.hidden) { rc.hidden = true; ssRaw('ab-resume-dicht', '1'); }
    meet('configurator_gestart', { herkomst: INIT.herkomst, bron: INIT.bron, had_ontwerpcode: INIT.hadCode });
  };

  root.addEventListener('change', (e) => {
    if (e.target.closest('[data-next]')) return;
    if (e.target.matches('[data-adv-x]')) { if (e.target.checked) dropped.delete(e.target.value); else dropped.add(e.target.value); }
    startMeting();
    render();
  });
  const setFin = (v) => {
    const el = root.querySelector(`input[name="fin"][value="${v}"]`);
    if (el) { el.checked = true; render(); }
    return el;
  };
  root.addEventListener('click', (e) => {
    const toE = e.target.closest('[data-to-eigen]');
    if (toE && hasEigen) {
      e.preventDefault();
      const el = setFin('eigen');
      startMeting();
      if (el) { el.focus({ preventScroll: true }); lkPanel.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
      return;
    }
    if (e.target.closest('[data-help]') && state().fin === 'eigen' && klant && klant.hasLogo()) {
      ssSet('ab-lk-terug', { at: Date.now(), logo: klant.hash() });
    }
    if (e.target.closest('[data-quote-btn]')) { e.preventDefault(); if (klant) klant.quoteFocus(); return; }
    const rs = e.target.closest('[data-adv-reset]');
    if (!rs || !advice) return;
    const el = root.querySelector(`input[name="flt"][value="${advice.main}"]`);
    if (el) { el.checked = true; startMeting(); render(); el.focus({ preventScroll: true }); }
  });

  // Volgende stap na een gelukte PDF of Deel ontwerp: een audicien zoeken (niet bij een eigen logo, daar volgt een offerte)
  const nextBox = $('[data-next]');
  const showMsg = (t) => { const m = $('[data-msg]'); if (!m) return; m.textContent = t || ''; m.classList.toggle('is-ok', !!t); };
  const openNext = () => {
    if (!nextBox || state().fin === 'eigen') return;
    const first = nextBox.hidden;
    nextBox.hidden = false;
    if (first) {
      const r = nextBox.getBoundingClientRect();
      if (r.bottom > window.innerHeight) nextBox.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };
  // De postcode gaat alleen als vier cijfers via sessionStorage naar de kaart, nooit in de url
  root.addEventListener('submit', (e) => {
    const f = e.target.closest && e.target.closest('[data-next-form]');
    if (!f) return;
    e.preventDefault();
    const inp = f.querySelector('[data-next-pc]'), err = f.querySelector('[data-next-err]');
    const raw = String(inp.value || '').trim(), m = /^(\d{4})\s*([a-z]{2})?$/i.exec(raw);
    if (raw && !m) { if (err) err.hidden = false; inp.setAttribute('aria-invalid', 'true'); inp.focus(); return; }
    if (err) err.hidden = true;
    inp.removeAttribute('aria-invalid');
    ssRaw('ab-zoek-postcode', m ? m[1] : null);
    const c = code(state());
    meet('naar_audicienkaart', { vanaf: 'volgende_stap', ontwerpcode: c, postcode_ingevuld: !!m, ontwerp_bewaard_deze_sessie: ssHas('ab-meet-pdf') });
    setTimeout(() => { location.href = kaartUrl(c); }, 150);
  });
  // Mail mijn ontwerp naar mezelf: een gewone mailto zonder adres, er worden geen gegevens verzameld.
  // Telt als delen. De klik gaat niet door naar de algemene telling van contactlinks in ab-meten.js (op document),
  // want er gaat geen mail naar Audibling. Daarom luisteren we op window in de capture-fase.
  window.addEventListener('click', (e) => {
    const a = e.target && e.target.closest && e.target.closest('[data-mailme]');
    if (!a || !root.contains(a)) return;
    e.stopPropagation();
    const s = state();
    a.href = mailHref(s);
    meet('ontwerp_gedeeld', { methode: 'mail', ontwerpcode: code(s), afwerking: finMeet(s), bron });
    openNext();
  }, true);
  // Kaart "Verder met je ontwerp". Het kleine script in de sectie heeft hem al getoond als er een bewaard ontwerp is.
  const resume = $('[data-resume]');
  if (resume) resume.addEventListener('click', (e) => {
    const open = e.target.closest('[data-resume-open]'), nieuw = e.target.closest('[data-resume-new]');
    if (!open && !nieuw) return;
    resume.hidden = true;
    ssRaw('ab-resume-dicht', '1');
    const h1 = $('.ab-cfg__intro h1');
    if (h1) { h1.setAttribute('tabindex', '-1'); h1.focus({ preventScroll: true }); }
    if (nieuw) return;
    const d = lsGet('ab-laatste-ontwerp');
    if (!d || !CODE_RX.test(d.code || '')) return;
    const h = typeof d.hash === 'string' && d.hash.indexOf('#ontwerp=' + d.code) === 0 && d.hash.length <= 4000 ? d.hash : '#ontwerp=' + d.code;
    history.replaceState(null, '', location.pathname + cleanSearch() + h);
    applyHash(readHash());
    persistOn = true;
    render();
    meet('ontwerp_hervat', { ontwerpcode: d.code, afwerking: finMeet(state()), dagen_oud: Math.max(0, Math.floor((Date.now() - (+d.t || Date.now())) / 864e5)) });
  });
  if (hasEigen) $$('[data-to-eigen]').forEach((a) => { if (a.dataset.eigenLabel) a.textContent = a.dataset.eigenLabel; });

  $$('[data-copy]').forEach((cb) => cb.addEventListener('click', async () => {
    const label = tr('Deel ontwerp');
    // bij een eigen logo eerst het logo opslaan, anders werkt de link op een ander apparaat niet
    if (state().fin === 'eigen' && klant && klant.hasLogo()) {
      cb.textContent = tr('Logo wordt opgeslagen'); cb.disabled = true;
      try { await klant.ensureUploaded(); render(); }
      catch (err) { $('[data-msg]').textContent = tr((err && err.message) || 'Je logo kon niet worden opgeslagen.'); cb.textContent = label; cb.disabled = false; return; }
      cb.disabled = false; cb.textContent = label;
    }
    const s = state(), c = code(s), url = shareUrl(s);
    let methode = '';
    // het deelmenu van het apparaat als dat er is, anders de link kopieren
    if (navigator.share) {
      try { await navigator.share({ title: (T.shareTitle || tr('Mijn Audibling ontwerp')) + ' ' + c, url }); methode = 'deelmenu'; showMsg(T.shareOk || ''); }
      catch (err) { if (err && err.name === 'AbortError') return; }
    }
    if (!methode) {
      try { await navigator.clipboard.writeText(url); cb.textContent = tr('Link gekopieerd ✓'); methode = 'klembord'; }
      catch { window.prompt(tr('Kopieer deze link'), url); methode = 'handmatig'; }
      setTimeout(() => (cb.textContent = label), 2500);
    }
    meet('ontwerp_gedeeld', { methode, ontwerpcode: c, afwerking: finMeet(s), bron });
    openNext();
  }));
  // Ontwerp-PDF voor de audicien
  const loadJsPDF = () => window.jspdf ? Promise.resolve(window.jspdf) : new Promise((res, rej) => {
    const sc = document.createElement('script');
    sc.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
    sc.onload = () => res(window.jspdf); sc.onerror = rej; document.head.appendChild(sc);
  });
  const toDataURL = (url) => new Promise((res) => {
    const im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = () => {
      try {
        const max = 1000, sc = Math.min(1, max / Math.max(im.width, im.height));
        const cv = document.createElement('canvas'); cv.width = Math.round(im.width * sc); cv.height = Math.round(im.height * sc);
        const cx = cv.getContext('2d'); cx.fillStyle = '#fff'; cx.fillRect(0, 0, cv.width, cv.height); cx.drawImage(im, 0, 0, cv.width, cv.height);
        res({ url: cv.toDataURL('image/jpeg', 0.85), w: cv.width, h: cv.height });
      } catch (e) { res(null); }
    };
    im.onerror = () => res(null);
    im.src = url;
  });
  // QR-code in de PDF: lui geladen, net als jsPDF. Lukt het laden niet, dan komt de PDF er zonder QR.
  const loadQR = () => window.qrcode ? Promise.resolve(window.qrcode) : new Promise((res, rej) => {
    const sc = document.createElement('script');
    sc.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcode-generator/1.4.4/qrcode.min.js';
    sc.onload = () => (window.qrcode ? res(window.qrcode) : rej(new Error('qr'))); sc.onerror = rej; document.head.appendChild(sc);
  });
  const QR_MAX = 900; // langere links (een eigen logo zit in de link) worden te fijn om te scannen
  const makeQR = (lib, text) => { const qr = lib(0, text.length > 160 ? 'L' : 'M'); qr.addData(text, 'Byte'); qr.make(); return qr; };
  // een link met een eigen logo is lang: dan een grotere code, zodat een blokje minstens 0,38 mm is en hij uitgeprint te scannen blijft
  const qrSize = (qr, min) => Math.min(40, Math.max(min, qr.getModuleCount() * 0.38));
  const drawQR = (doc, qr, x, y, size) => {
    const n = qr.getModuleCount(), m = size / n;
    doc.setFillColor(255, 255, 255); doc.roundedRect(x - 2.5, y - 2.5, size + 5, size + 5, 2, 2, 'F');
    doc.setFillColor(26, 28, 43);
    for (let r = 0; r < n; r++) {
      let c0 = -1;
      for (let cc = 0; cc <= n; cc++) {
        const dark = cc < n && qr.isDark(r, cc);
        if (dark && c0 < 0) c0 = cc;
        if (!dark && c0 >= 0) { doc.rect(x + c0 * m, y + r * m, (cc - c0) * m, m + 0.03, 'F'); c0 = -1; }
      }
    }
  };
  // Minteken in de PDF als getekende lijn (24 oktober 2026). Helvetica in jsPDF gebruikt WinAnsi, daarin staat geen minteken (U+2212),
  // en een koppelteken willen we niet als minteken. xr is de linkerkant van het bedrag, yb de basislijn, size de korps in punt.
  const pdfMinus = (doc, xr, yb, size, col) => {
    const em = size * 25.4 / 72, lw0 = doc.getLineWidth ? doc.getLineWidth() : 0.2;
    doc.setDrawColor(...col); doc.setLineWidth(em * 0.075);
    const x1 = xr - em * 0.1, y = yb - em * 0.31;
    doc.line(x1 - em * 0.46, y, x1, y);
    doc.setLineWidth(lw0);
  };
  const buildPdf = async () => {
    const s = state();
    // eigen logo: render, ontwerpcode, prijs en wat er nu gebeurt (gegevens uit de klanttool)
    const P = s.fin === 'eigen' && klant ? await klant.pdfData() : null;
    if (s.fin === 'eigen' && !P) { const e = new Error(tr('Kies eerst je logo, dan kun je je ontwerp bewaren.')); e.code = 'geen-logo'; throw e; }
    const { jsPDF } = await loadJsPDF();
    const qrLib = await loadQR().catch(() => null);
    const c = code(s), ex = extrasFor(s);
    const ink = [26, 28, 43], blue = [47, 79, 216], mut = [85, 88, 103];
    const made = trf('Gemaakt op {datum}', { datum: new Date().toLocaleDateString(LOC, { day: 'numeric', month: 'long', year: 'numeric' }) });
    // links in de PDF krijgen utm, zodat je ziet dat iemand via de PDF terugkomt
    const online = P ? (P.url ? withUtm(P.url) : '') : withUtm(shareUrl(s));
    const apptPdf = kaartUrl(c, true);
    // gegevens die niet per opmaakpoging veranderen
    let photo = null;
    const pimg = root.querySelector('.ab-cfg__photo'), pcap = root.querySelector('.ab-cfg__photocap');
    if (!P && pimg && !pimg.hidden && pimg.src) photo = (await toDataURL(pimg.dataset.full || pimg.src)) || (await toDataURL(pimg.currentSrc || pimg.src));
    const capTxt = pcap && !pcap.hidden ? pcap.textContent : '';
    const priceRows = P ? [] : $$('[data-lines] > div:not(.is-advice)').map((row) => [...row.children].map((x) => x.textContent));
    const totalTxt = P ? '' : ($('.ab-cfg__total [data-out="total"]') || $('[data-out="total"]')).textContent;
    const custom = s.col === 'Speciale kleur' ? ' (' + (root.querySelector('[name="custom_color"]').value || tr('in overleg')) + ')' : '';

    // Alles moet op een A4. Past het niet, dan probeert de opmaak het iets compacter (lvl 0 tot 5):
    // 1 kleinere tekst, 2 advies op een regel per filter, 3 zonder de afspraakregels, 4 hooguit zes audiciens, 5 zonder audiciens.
    const draw = (lvl) => {
      const doc = new jsPDF({ unit: 'mm', format: 'a4' });
      const last = lvl >= 5;
      let y = 0, over = false;
      const font = (size, bold, color) => { doc.setFontSize(size); doc.setFont('helvetica', bold ? 'bold' : 'normal'); doc.setTextColor(...(color || ink)); };
      const room = (h) => { if (y + h > 281) { if (last) { doc.addPage(); y = 20; } else over = true; } };
      doc.setFillColor(47, 79, 216); doc.rect(0, 0, 210, 34, 'F');
      font(22, true, [255, 255, 255]); doc.text('audibling', 18, 21);
      font(10, false, [255, 255, 255]); doc.text(tr('Jouw ontwerp voor oordoppen op maat'), 18, 28);
      font(10.5, true, [255, 255, 255]); doc.text(P ? tr('Jouw ontwerp met eigen logo') : T.pdfH, 192, 28, { align: 'right' });
      font(12, true); doc.text(tr('Ontwerpcode'), 18, 48);
      font(26, true, blue); doc.text(c, 18, 60);
      font(9, false, mut); doc.text(made, 18, 67);
      if (online) { doc.setTextColor(...blue); doc.textWithLink(tr('Bekijk dit ontwerp online'), 18, 73, { url: online }); }
      if (P) {
        const pdfEur = (n) => P.price ? (EN ? '€' + (Math.round(n * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '€' + (Math.round(n * 100) / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')) : '';
        // je logo op de dop, vergroot en op ware grootte (rechts naast de code)
        font(9, true); doc.text(tr('Je logo op de dop'), 120, 44);
        const big = 30, k = big / P.D, fm = P.flatMm;
        try {
          doc.addImage(P.flat, 'PNG', 120 + big / 2 - fm * k / 2, 48 + big / 2 - fm * k / 2, fm * k, fm * k);
          doc.addImage(P.flat, 'PNG', 168 + P.D / 2 - fm / 2, 58 + P.D / 2 - fm / 2, fm, fm);
        } catch (e) { /* zonder beeld verder */ }
        doc.setDrawColor(200, 196, 188); doc.setLineWidth(0.2);
        doc.circle(120 + big / 2, 48 + big / 2, big / 2); doc.circle(168 + P.D / 2, 58 + P.D / 2, P.D / 2);
        font(8, false, mut); doc.text(tr('Vergroot'), 120 + big / 2, 82, { align: 'center' }); doc.text(tr('Ware grootte'), 168 + P.D / 2, 74, { align: 'center' });
        // render op de productfoto, met rechts ernaast de QR-code naar dit ontwerp (als de link niet te lang is)
        y = 88;
        let qrE = null;
        try { if (qrLib && online && online.length <= QR_MAX) qrE = makeQR(qrLib, online); } catch (e) { qrE = null; }
        const QE = qrE ? qrSize(qrE, 24) : 0, areaW = qrE ? 174 - QE - 8 : 174;
        let rh = [70, 64, 58, 52, 52, 52][lvl];
        try {
          const w = Math.min(areaW, rh * (P.rw / P.rh));
          rh = w / (P.rw / P.rh);
          doc.addImage(P.render, 'JPEG', 18 + areaW / 2 - w / 2, y, w, rh);
        } catch (e) { /* zonder render verder */ }
        if (qrE) {
          try {
            font(7.5, false);
            const lb = doc.splitTextToSize(T.qrL, QE + 6);
            const qy = y + Math.max(0, (rh - QE - 3 - lb.length * 3.1) / 2), qx = 192 - QE;
            drawQR(doc, qrE, qx, qy, QE);
            font(7.5, false, mut); doc.text(lb, qx + QE / 2, qy + QE + 5, { align: 'center' });
            rh = Math.max(rh, qy - y + QE + 5 + lb.length * 3.1);
          } catch (e) { /* zonder QR verder */ }
        }
        y += rh + 4;
        font(8.5, false, mut);
        const capL = doc.splitTextToSize(P.renderCap, 174); doc.text(capL, 18, y); y += capL.length * 3.6 + 6;
        // keuzes links, prijs rechts
        const rows = [[tr('Materiaal'), tr(s.mat)], [tr('Kleur'), tr(s.col) + custom],
          ['Filter', FILTER_NAME[s.flt]], [tr('Afwerking'), tr('Eigen logo')], [tr('Logobestand'), P.logoName], [tr('Achtergrond dop'), P.bg], [tr('Aantal'), trf('{n} stuks', { n: P.qty })]];
        if (ex.length) rows.push(['Extra filters', trf('{lijst} (advies)', { lijst: listNl([...new Set(ex.map(fOf))]) })]);
        const pr = P.price;
        font(9, false);
        const priceLines = pr ? pr.lines.map(([l, v]) => [doc.splitTextToSize(l, 50), pdfEur(Math.abs(v)), v < 0]) : [];
        const noteL = doc.splitTextToSize(P.priceNote || '', 74);
        const priceH = pr ? 12 + priceLines.reduce((t, [l]) => t + l.length * 4.2 + 1, 0) + 19 + noteL.length * 3.4 + 1 : 0;
        const rowsH = 8 + rows.length * 6.4;
        room(Math.max(priceH, rowsH) + 4);
        let ly = y;
        font(12, true); doc.text(tr('Jouw keuzes'), 18, ly); ly += 7;
        rows.forEach(([kk, v]) => {
          const vl = doc.splitTextToSize(String(v), 50);
          font(9.5, false, mut); doc.text(kk, 18, ly);
          font(9.5, true); doc.text(vl, 52, ly); ly += 5.6 * vl.length + 0.8;
        });
        if (pr) {
          let py = y - 6;
          doc.setFillColor(231, 236, 253); doc.roundedRect(112, py, 80, priceH, 4, 4, 'F');
          py += 8; font(11, true); doc.text(tr('Prijsindicatie'), 118, py); py += 6;
          priceLines.forEach(([l, v, neg]) => { font(9, false); doc.text(l, 118, py); doc.text(v, 186, py, { align: 'right' }); if (neg) pdfMinus(doc, 186 - doc.getTextWidth(v), py, 9, ink); py += l.length * 4.2 + 1; });
          doc.setDrawColor(190, 198, 235); doc.line(118, py - 2, 186, py - 2);
          font(10.5, true); doc.text(tr('Totaal excl. btw'), 118, py + 3); doc.text(pdfEur(pr.ex), 186, py + 3, { align: 'right' }); py += 8;
          font(9, false); doc.text(trf('Incl. {btw}% btw', { btw: pr.vat }), 118, py); doc.text(pdfEur(pr.inc), 186, py, { align: 'right' }); py += 5;
          doc.text(tr('Per stuk excl. btw'), 118, py); doc.text(pdfEur(pr.pp), 186, py, { align: 'right' }); py += 6;
          font(8, false, mut); doc.text(noteL, 118, py);
          ly = Math.max(ly, y - 6 + priceH);
        }
        y = ly + 5;
        // wat er nu gebeurt
        font(9, false);
        const steps = P.next.map((t, i) => doc.splitTextToSize((i + 1) + '. ' + t, 162));
        const boxH = 13 + steps.reduce((t, l) => t + l.length * 4.1 + 1.2, 0);
        room(boxH);
        doc.setFillColor(251, 248, 244); doc.roundedRect(18, y, 174, boxH, 4, 4, 'F');
        font(11.5, true); doc.text(P.nextH, 24, y + 8.5);
        let sy = y + 15;
        steps.forEach((l) => { font(9, false); doc.text(l, 24, sy); sy += l.length * 4.1 + 1.2; });
        y += boxH;
      } else {
        // foto rechts naast de code en de keuzes
        let photoBottom = 0;
        if (photo) {
          try {
            // compacter: een kleinere foto, rechts uitgelijnd
            const w = [72, 72, 64, 56, 56, 56][lvl], h = Math.min(90, w * (photo.h / photo.w)), px = 192 - w;
            doc.addImage(photo.url, 'JPEG', px, 40, w, h); photoBottom = 40 + h + 4;
            if (capTxt) {
              font(8.5, false, mut);
              const cl = doc.splitTextToSize(capTxt, w);
              doc.text(cl, px, photoBottom); photoBottom += cl.length * 3.6 + 2;
            }
          } catch (e) { photoBottom = 0; }
        }
        const rows = [[tr('Materiaal'), tr(s.mat)], [tr('Kleur'), tr(s.col) + custom],
          ['Filter', FILTER_NAME[s.flt]], [tr('Afwerking'), s.fin === 'logo' ? logoTxt(s.logo) : s.fin === 'gem' ? trf('Sieraadsteen {steen}', { steen: tr(s.gem) }) : tr('Geen')]];
        y = 84;
        font(12, true); doc.text(tr('Jouw keuzes'), 18, y); y += 7;
        rows.forEach(([k, v]) => {
          const vl = doc.splitTextToSize(String(v), 64);
          font(11, false, mut); doc.text(k, 18, y);
          font(11, true); doc.text(vl, 48, y); y += 6.5 * vl.length + 0.5;
        });
        y = Math.max(y, photoBottom) + 4;
        // advies uit de keuzehulp met de extra filtersets die bij dit ontwerp horen (compacter: zonder de uitleg per filter)
        if (advice && (bron === 'keuzehulp' || ex.length)) {
          font(9, false);
          const items = [];
          if (bron === 'keuzehulp') items.push({ k: tr(s.flt === advice.main ? 'Hoofdfilter in je oordop' : 'Advies voor je hoofdfilter'), f: advice.main, str: strTxt(advice.main) });
          ex.forEach((k) => items.push({ k: tr(isSecond(k) ? 'Tweede filterset in een andere sterkte' : 'Extra filterset bij je ontwerp'), kc: tr(isSecond(k) ? 'Tweede filterset' : 'Extra filterset'), f: fOf(k), str: isSecond(k) ? '' : strTxt(fOf(k)) }));
          items.forEach((it) => { it.lines = fltWhy(it.f) && lvl < 2 ? doc.splitTextToSize(fltWhy(it.f), 160) : []; });
          const exReq = [...new Set(ex.map(fOf).filter((f) => !canBuy(f)))];
          const reqLines = exReq.length ? doc.splitTextToSize(trf('Voor een extra {lijst}-filterset staat nog geen prijs online. Vraag hem aan per mail via {mail} en noem daarbij je ontwerpcode {code}.', { lijst: listNl(exReq), mail: T.mail, code: c }), 160) : [];
          // compact: een regel per filter (soort links, filter en sterkte rechts)
          const compact = lvl >= 2;
          if (compact) items.forEach((it) => { it.k = it.kc || it.k; });
          const arh = lvl >= 4 ? 5 : 5.8;
          const h = 15 + (compact ? items.length * arh : items.reduce((t, it) => t + 10.4 + (it.str ? 4.2 : 0) + it.lines.length * 4, 0)) + (exReq.length ? 9 + reqLines.length * 4 : 0);
          room(h + 6);
          doc.setFillColor(231, 236, 253); doc.roundedRect(18, y, 174, h, 4, 4, 'F');
          let yy = y + 9;
          font(12, true); doc.text(bron === 'keuzehulp' ? T.advH : T.advH2, 24, yy); yy += 7.5;
          if (compact) items.forEach((it) => {
            font(8.5, false, mut); doc.text(it.k, 24, yy);
            font(10.5, true); const nm = FILTER_NAME[it.f]; doc.text(nm, 70, yy);
            if (it.str) { const wN = doc.getTextWidth(nm); font(9, true, blue); doc.text(it.str, 70 + wN + 4, yy); }
            yy += arh;
          });
          else items.forEach((it) => {
            font(8.5, false, mut); doc.text(it.k, 24, yy); yy += 4.4;
            font(11, true); doc.text(FILTER_NAME[it.f], 24, yy); yy += 4.8;
            if (it.str) { font(9, true, blue); doc.text(it.str, 24, yy); yy += 4.2; }
            if (it.lines.length) { font(9, false, mut); doc.text(it.lines, 24, yy); yy += it.lines.length * 4; }
            yy += 1.2;
          });
          if (exReq.length) {
            yy += 1.5; font(11, true, blue); doc.text(T.req, 24, yy); yy += 4.8;
            font(9, false); doc.text(reqLines, 24, yy);
          }
          y += h + (lvl < 2 ? 9 : 8);
        }
        // prijs inclusief aanmeten links, wat je met de PDF doet rechts
        const nfs = lvl === 0 ? 9.5 : 9, nlh = nfs * 0.3528 * 1.15; // regelafstand zoals jsPDF hem tekent
        font(nfs, false);
        const nextLines = doc.splitTextToSize(T.pdfNext, 68);
        const boxH = 15 + nextLines.length * nlh + 9;
        font(9, false);
        const exReqP = [...new Set(ex.map(fOf).filter((f) => !canBuy(f)))];
        const payTxt = [T.payNote ? T.payNote.replace(/[.\s]*$/, '.') : '', exReqP.length ? tr('Een extra filterset die je per mail aanvraagt, staat niet in dit totaal.') : ''].filter(Boolean).join(' ');
        const payLines = payTxt ? doc.splitTextToSize(payTxt, 86) : [];
        const pfs = lvl >= 4 ? 9.5 : 10.5, prh = lvl >= 4 ? 4.9 : 5.8; // compacter: kleinere prijsregels
        font(pfs, false);
        const priceH = 7 + priceRows.reduce((t, [a]) => t + doc.splitTextToSize(a, 64).length * prh, 0) + 9 + payLines.length * 4 + 2;
        room(Math.max(boxH - 6, priceH) + 2);
        let py = y;
        font(12, true); doc.text(T.totalL, 18, py); py += 7;
        priceRows.forEach(([a, b]) => {
          font(pfs, false); const al = doc.splitTextToSize(a, 64);
          doc.text(al, 18, py); doc.text(b, 104, py, { align: 'right' }); py += al.length * prh;
        });
        doc.setDrawColor(230, 225, 215); doc.line(18, py - 2, 104, py - 2);
        font(13, true); doc.text(tr('Totaal'), 18, py + 4); doc.text(totalTxt, 104, py + 4, { align: 'right' }); py += 9;
        if (payLines.length) { font(9, false, mut); doc.text(payLines, 18, py + 1); py += 1 + payLines.length * 4; }
        const by = y - 6;
        doc.setFillColor(251, 248, 244); doc.roundedRect(112, by, 80, boxH, 4, 4, 'F');
        font(11, true); doc.text(T.pdfH, 118, by + 9);
        font(nfs, false); doc.text(nextLines, 118, by + 15);
        font(9.5, true, blue); doc.textWithLink(T.apptL, 118, by + 15 + nextLines.length * nlh + 3, { url: apptPdf });
        y = Math.max(py, by + boxH) + 6;
        // Hier kun je terecht: de aangesloten audiciens, wat je zegt als je belt en een QR-code naar dit ontwerp
        let qrN = null;
        try { if (qrLib && online.length <= QR_MAX) qrN = makeQR(qrLib, online); } catch (e) { qrN = null; }
        const qrOn = !!qrN, QS = qrN ? qrSize(qrN, [28, 25, 24, 22, 20, 20][lvl]) : 0, cols = lvl === 0 ? 2 : 3;
        const leftW = 174 - 12 - (qrOn ? QS + 10 : 0), colW = (leftW - (cols - 1) * 5) / cols;
        const list = lvl < 4 ? DEALERS.slice(0, 12) : lvl < 5 ? DEALERS.slice(0, 6) : [];
        font(9.5, true);
        const callL = T.whereCall ? doc.splitTextToSize(T.whereCall, leftW) : [];
        font(9, false);
        const apptL = lvl < 3 && T.whereAppt ? doc.splitTextToSize(T.whereAppt, leftW) : [];
        const ent = list.map((d) => {
          font(9, true); const nl = doc.splitTextToSize(d.name, colW);
          font(8.5, false); const il = doc.splitTextToSize([d.city, d.phone].filter(Boolean).join(' · '), colW);
          return { nl, il, h: nl.length * 3.8 + il.length * 3.6 + 2.4 };
        });
        const rowH = [];
        for (let i = 0; i < ent.length; i += cols) rowH.push(Math.max(...ent.slice(i, i + cols).map((e) => e.h)));
        font(7.5, false);
        const qrLbl = qrOn ? doc.splitTextToSize(T.qrL, QS + 10) : [];
        const leftH = 9 + 6 + callL.length * 4.2 + (apptL.length ? apptL.length * 4 + 1.5 : 0) + (ent.length ? 3 + rowH.reduce((a, b) => a + b, 0) : 2) + 6;
        const rightH = qrOn ? 11 + QS + qrLbl.length * 3.1 : 0;
        const wH = Math.max(leftH, rightH);
        room(wH);
        doc.setFillColor(231, 236, 253); doc.roundedRect(18, y, 174, wH, 4, 4, 'F');
        let wy = y + 9;
        font(12, true); doc.text(T.whereH, 24, wy); wy += 6;
        font(9.5, true, blue); callL.forEach((l) => { doc.text(l, 24, wy); wy += 4.2; });
        if (apptL.length) { font(9, false); apptL.forEach((l) => { doc.text(l, 24, wy); wy += 4; }); wy += 1.5; }
        if (ent.length) {
          wy += 3;
          for (let i = 0; i < ent.length; i += cols) {
            ent.slice(i, i + cols).forEach((e, j) => {
              const x = 24 + j * (colW + 5);
              let ey = wy;
              font(9, true); e.nl.forEach((l) => { doc.text(l, x, ey); ey += 3.8; });
              font(8.5, false, mut); e.il.forEach((l) => { doc.text(l, x, ey); ey += 3.6; });
            });
            wy += rowH[i / cols];
          }
        } else wy += 2;
        font(9.5, true, blue); doc.textWithLink(T.whereAll, 24, wy + 1.5, { url: apptPdf });
        if (qrOn) {
          const qx = 186 - QS, qy = y + 5.5;
          try { drawQR(doc, qrN, qx, qy, QS); font(7.5, false, mut); doc.text(qrLbl, qx + QS / 2, qy + QS + 5, { align: 'center' }); } catch (e) { /* zonder QR verder */ }
        }
        y += wH;
      }
      const pages = doc.getNumberOfPages();
      for (let p = 1; p <= pages; p++) {
        doc.setPage(p); font(8.5, false, mut);
        doc.text('Audibling  ·  www.audibling.nl  ·  +31 85 060 9439  ·  info@audibling.nl', 105, 287, { align: 'center' });
      }
      return { doc, over: over || pages > 1 };
    };
    let res = null;
    for (let lvl = 0; lvl <= 5; lvl++) { res = draw(lvl); if (!res.over) break; }
    return { doc: res.doc, name: trf('audibling-ontwerp-{code}.pdf', { code: c }) };
  };
  // aanleiding: knop (de PDF-knop) of na_offerte (de PDF na een offerte met eigen logo, via de klanttool)
  const savePdf = async (aanleiding) => {
    const { doc, name } = await buildPdf();
    doc.save(name);
    ssRaw('ab-meet-pdf', '1');
    const s = state();
    meet('ontwerp_bewaard', { ontwerpcode: code(s), materiaal: s.mat === 'Siliconen' ? 'siliconen' : 'hard', filter: s.flt, afwerking: finMeet(s),
      aantal_extra_filtersets: extrasFor(s).length, bron, aanleiding: aanleiding === 'knop' ? 'knop' : 'na_offerte', value: lastValue, currency: 'EUR' });
  };
  $('[data-print]').addEventListener('click', async () => {
    const btn = $('[data-print]'), label = btn.textContent;
    btn.disabled = true; btn.textContent = tr('PDF maken…');
    showMsg('');
    let ok = false;
    try {
      await savePdf('knop');
      ok = true;
    } catch (e) {
      $('[data-msg]').textContent = e && e.code === 'geen-logo' ? e.message : tr('De PDF kon niet worden gemaakt. Probeer het opnieuw.');
    }
    btn.disabled = false; btn.textContent = label;
    if (ok && state().fin !== 'eigen') { showMsg(T.pdfOk); openNext(); }
  });

  // Koppeling met de klanttool voor een eigen logo (assets/ab-logo-klant.js)
  let posted = null;
  const postedEl = root.querySelector('[data-lk-posted]');
  if (postedEl && hasEigen) {
    // Shopify stuurt na het offerteformulier terug naar deze pagina. Het ontwerp staat nog in deze browsersessie.
    let info = ssGet('ab-lk-send');
    if (info && !(Date.now() - info.at < 6 * 3600e3)) info = null;
    posted = { state: postedEl.dataset.lkPosted, errors: postedEl.dataset.lkErrors || '', info };
    history.replaceState(null, '', location.pathname + (info && info.hash ? info.hash : '#ontwerp=AB-H0-DR-E'));
  }
  const bridge = {
    root, view, panel: lkPanel, quote: lkQuote, T: LK, posted,
    tr, trf, EN, // taal voor de klanttool
    state, refresh: () => render(), setFin,
    extras: () => [...new Set(extrasFor(state()).map(fOf))],
    customColor: () => (root.querySelector('[name="custom_color"]') || {}).value || '',
    pdf: savePdf,
  };

  // naar de configurator scrollen als de bezoeker uit de keuzehulp komt
  const toAdvice = () => {
    const box = $('[data-advice]');
    if (!box || box.hidden) return;
    const mobile = window.matchMedia('(max-width:960px)').matches;
    const stage = $('.ab-cfg__stage'), step = box.closest('fieldset') || box;
    // de voorbeeldfoto blijft in beeld (sticky), dus scrollen naar de dempingstap
    const y = step.getBoundingClientRect().top + window.pageYOffset - (mobile && stage ? stage.offsetHeight + 8 : 16);
    // direct springen, ook als het thema smooth scroll gebruikt
    const html = document.documentElement, prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, Math.max(0, Math.round(y)));
    html.style.scrollBehavior = prev;
    const hd = box.querySelector('.ab-cfg__advh');
    if (hd) hd.focus({ preventScroll: true });
    return Math.round(window.pageYOffset);
  };

  const h0 = readHash();
  DEFAULT_HASH = hashFor(state());
  INIT = (() => {
    let ref = null;
    try { ref = document.referrer ? new URL(document.referrer) : null; } catch { ref = null; }
    const same = !!ref && ref.origin === location.origin, hadCode = CODE_RX.test(h0.code), b = h0.bron;
    const herkomst = b === 'keuzehulp' ? 'keuzehulp'
      : /^product/.test(b) || (same && /^\/products\//.test(ref.pathname)) ? 'product'
        : hadCode && !same && !b ? 'gedeelde_link'
          : same ? 'intern' : ref ? 'extern' : 'direct';
    return { herkomst, bron: b, hadCode };
  })();
  applyHash(h0);
  if (INIT.hadCode) persistOn = true;
  render();
  // utm_* pas uit de adresbalk halen als Shopify het bezoek heeft kunnen tellen
  const utmLater = () => setTimeout(() => {
    utmWeg = true;
    if (/[?&]utm_/i.test(location.search)) history.replaceState(null, '', location.pathname + cleanSearch() + location.hash);
  }, 4000);
  if (document.readyState === 'complete') utmLater(); else window.addEventListener('load', utmLater, { once: true });
  // Met een eigen logo in de link (E-code) of vanaf een zakelijke pagina direct naar stap 4 met het logopaneel
  const LOGO_BRON = ['zakelijk', 'logopagina', 'proefontwerp', 'vereniging', 'bedankt'];
  const toStep4 = () => {
    const step = $('[data-step-fin]');
    if (!step) return null;
    const mobile = window.matchMedia('(max-width:960px)').matches, stage = $('.ab-cfg__stage');
    const y = step.getBoundingClientRect().top + window.pageYOffset - (mobile && stage ? stage.offsetHeight + 8 : 16);
    const html = document.documentElement, prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, Math.max(0, Math.round(y)));
    html.style.scrollBehavior = prev;
    return Math.round(window.pageYOffset);
  };
  if (!posted && ((CODE_RX.test(h0.code) && /-E[A-Z0-9]*$/i.test(h0.code)) || LOGO_BRON.includes(bron))) {
    const y0 = window.pageYOffset;
    const go = () => {
      if (Math.abs(window.pageYOffset - y0) > 4) return; // de bezoeker scrolt zelf al
      const first = toStep4();
      const again = () => { if (first != null && Math.abs(window.pageYOffset - first) < 4) toStep4(); };
      if (document.readyState === 'complete') setTimeout(again, 300); else window.addEventListener('load', again, { once: true });
    };
    if (val('fin') === 'eigen' && klantP) klantP.then(go, go); else go();
  }
  if (bron === 'keuzehulp') {
    const first = toAdvice();
    // na het laden van lettertypen en beelden nog een keer, als de bezoeker zelf nog niet heeft gescrold
    window.addEventListener('load', () => { if (first != null && Math.abs(window.pageYOffset - first) < 4) toAdvice(); }, { once: true });
  }
  // een gedeelde link openen terwijl de pagina al openstaat (alleen de hash verandert)
  window.addEventListener('hashchange', () => {
    const h = readHash();
    if (!CODE_RX.test(h.code)) return;
    const s = state();
    if (('#' + location.hash.replace(/^#/, '')) === hashFor(s)) return;
    applyHash(h); persistOn = true; render();
    if (bron === 'keuzehulp') toAdvice();
  });
})();
